<template>
  <card>
    <template #header>
      <h2 class="font-medium text-blue dark:text-white">
        <slot/>
      </h2>
    </template>

    <template #body>
      <div :id="id" class="mt-3 pr-3"/>
      At least 75% of an ABA-approved law school's graduates who take the bar exam must pass the exam within two years of graduation under the ABA accreditation rules.
    </template>
  </card>
</template>

<script setup>
import Card from "@/components/cards/Card.vue"
import Highcharts from "@/highcharts"
import { onMounted } from "vue"

import colors from "@/colors"
import { percent } from "@/support"

const props = defineProps({
  id: { type: String, required: true },
  school: { type: Object, required: true },
})

onMounted(() => {
  const options = {
    chart: { height: 350 },
    legend: { enabled: false },
    title: { text: "" },
    credits: { enabled: false },
    subtitle: { text: "" },
    xAxis: {
      title: {
        text: "Graduation year",
      },
      categories: props.school.ultimate_bar_pass_rates.map((item) => item.graduation_year),
    },
    yAxis: { min: 0, max: 100, labels: { format: "{value}%" }, title: { text: "Two-year pass rate" }, allowDecimals: false, plotLines: [{
      color: "#FF0000",
      width: 2,
      value: 75,
      label: {
        text: "Accreditation requirement (75%)",
        style: {
          color: colors.nonEmployed,
          fontWeight: 500,
        },
      },
    }] },
    tooltip: {
      crosshairs: true,
      shared: true,
      formatter() {
        let s = `<span style="font-size: 16px;font-weight:600;">${this.x}</span>`

        $.each(this.points, (i, point) => {
          s += `<br/><span style="font-size:14px;font-weight:400;">${point.series.name}: ${
            point.y}%</span>`
        })

        return s
      },
    },
    series: [
      {
        type: "spline",
        color: colors.darkBlue,
        name: "Two-year pass rate",
        marker: { radius: 2, lineColor: "#666666", lineWidth: 1 },
        dataLabels: { useHTML: true, enabled: false, format: "{y}%", x: 0, y: -1 },
        data: props.school.ultimate_bar_pass_rates.map((item) => percent(item.passers, item.takers)),
      },
    ],
  }

  new Highcharts.chart(props.id, options)
})
</script>
